'use strict';

module.exports = onRepeatRenderedDirective;

//source http://stackoverflow.com/questions/15207788/calling-a-function-when-ng-repeat-has-finished
function onRepeatRenderedDirective() {
  return function (scope, element, attrs) {
    if (scope.$last) { // all are rendered
      scope.$eval(attrs.onRepeatRendered);
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/ng-repeat-utils/ngRepeatEvents.js